import Constants from '@/Constants';
import { PushNotificationPaginationData } from '@/models/PushNotificationPaginationData';
import { PushNotificationRequest } from '@/models/PushNotificationRequest';
import { ApplicationState } from '@/store';
import { getPushNotificationListRequest } from '@/store/pushNotification/action';
import { PushNotification, PushNotificationTypes } from '@/store/pushNotification/types';
import PerfectScrollbar from 'perfect-scrollbar';
import React, { RefObject, useCallback, useEffect, useState } from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useDispatch, useSelector } from 'react-redux';
import EmptySection from '../EmptySection';
import Loader from '../Loader';
import NotificationCard from '../NotificationCard';
import './style.scss';

interface Props {
    active?: boolean;
}

const AllNotifications: React.FC<Props> = (props: Props) => {
    const { active } = props;

    const { listOfAllNotifications, listTotal, loading, strings } = useSelector((state: ApplicationState) => ({
        listOfAllNotifications: state.pushNotification.data.listAllPushNotification.list,
        listTotal: state.pushNotification.data.listAllPushNotification.total,
        loading: state.pushNotification.loading,
        strings: state.locale.data,
    }));

    const [perfectScrollbar, setPerfectScrollbar] = useState<PerfectScrollbar>();

    const dispatch = useDispatch();

    const getNotificationsList = () => {
        const pushNotificationRequest = {
            uncheckedOnly: false,
            paginationData: {
                limit: 5,
                offset: listOfAllNotifications.length,
                requestSuccessType: PushNotificationTypes.ALL_PUSH_NOTIFICATION_LIST_SUCCESS,
            } as PushNotificationPaginationData,
        } as PushNotificationRequest;

        dispatch(getPushNotificationListRequest(pushNotificationRequest));
    };

    useEffect(() => {
        setPerfectScrollbar(new PerfectScrollbar('#all-scrollbar', { wheelPropagation: false }));
        if (listOfAllNotifications.length === 0) {
            getNotificationsList();
        }
    }, [dispatch]);

    useEffect(() => {
        updatePerfectScrollbar();
    }, [listOfAllNotifications.length]);

    useEffect(() => {
        if (active) {
            updatePerfectScrollbar();
        }
    }, [active]);

    const updatePerfectScrollbar = () => {
        if (perfectScrollbar) {
            setTimeout(() => {
                perfectScrollbar.update();
            }, 500);
        }
    };

    const callback = useCallback(() => {
        if (listOfAllNotifications.length < listTotal && !loading) {
            getNotificationsList();
        }
    }, [listOfAllNotifications.length]);

    const scrollRef: RefObject<HTMLDivElement> = useBottomScrollListener(callback, { offset: 200 });

    return (
        <div id="all-scrollbar" ref={scrollRef}>
            {listOfAllNotifications.map((notification: PushNotification) => (
                <NotificationCard key={`all_${notification.id}`} notification={notification} />
            ))}
            {!loading && listOfAllNotifications.length === 0 && (
                <EmptySection iconName={Constants.icons.SMS_FAILED} message={strings.EMPTY_SECTION_MESSAGE} style={{ height: '100%' }} />
            )}
            {loading && listOfAllNotifications.length === 0 && <Loader />}
            {loading && listOfAllNotifications.length !== 0 && <Loader spinnerHeight={30} spinnerWidth={30} styles={{ height: '12%', padding: 0 }} />}
        </div>
    );
};

export default AllNotifications;
